import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ArchiveCenter from "@/pages/admin/ArchiveCenter";
import AuditLogs from "@/pages/admin/AuditLogs";
import EmailLog from "@/pages/admin/EmailLog";
import DeletionVerify from "@/pages/admin/DeletionVerify";

export default function Archive() {
  const [tab, setTab] = useState("center");
  return (
    <div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="archive-tabs">
          <TabsTrigger value="center" data-testid="archive-tab-center">Archive Center</TabsTrigger>
          <TabsTrigger value="logs" data-testid="archive-tab-logs">Audit Logs</TabsTrigger>
          <TabsTrigger value="email" data-testid="archive-tab-email">Email Log</TabsTrigger>
          <TabsTrigger value="verify" data-testid="archive-tab-verify">Deletion Verify</TabsTrigger>
        </TabsList>
        <TabsContent value="center" data-testid="archive-panel-center"><ArchiveCenter /></TabsContent>
        <TabsContent value="logs" data-testid="archive-panel-logs"><AuditLogs /></TabsContent>
        <TabsContent value="email" data-testid="archive-panel-email"><EmailLog /></TabsContent>
        <TabsContent value="verify" data-testid="archive-panel-verify"><DeletionVerify /></TabsContent>
      </Tabs>
    </div>
  );
}
